import { attr, belongsTo, hasMany } from 'spraypaint';
import ApplicationRecord from './ApplicationRecord';

const Channel = ApplicationRecord.extend({
  attrs: {
    name: attr(),
    archived: attr(),
    parent: belongsTo({ type: 'vouchers-channels', persist: false }),
    children: hasMany({ type: 'vouchers-channels', persist: false }),
  },
  static: {
    endpoint: '/channels',
    jsonapiType: 'vouchers-channels',
    children() {
      return this.where({ parent_id: { not_eq: 'null' } });
    },
    parents() {
      return this.where({ parent_id: { eq: 'null' } });
    },
  },
});

export default Channel;
